import { Diagnosis } from '@dreryk/egabinet-patient-medical-information-frontend-api';

import { Translate } from '@dreryk/react-common';
import { CheckIcon, IconSize, IconWrapper, SidePanelSlots, StrongText, StyledFlex } from '@dreryk/react-components';

import { sidePanelTranslationKeys } from '../../../translations';

type DiagnosisCategoryContentProps = {
   readonly diagnosis: Diagnosis;
};

export const DiagnosisCategoryContent = (props: DiagnosisCategoryContentProps): JSX.Element => {
   return (
      <StyledFlex direction={'column'} gap={10}>
         {props.diagnosis.icd10 ? (
            <StrongText testId={'diagnosisName'}>
               {props.diagnosis.icd10.getCode().asString()} {props.diagnosis.icd10.getName().asString()}
            </StrongText>
         ) : null}

         {props.diagnosis.additionalInformation ? (
            <SidePanelSlots.Expandable>{props.diagnosis.additionalInformation}</SidePanelSlots.Expandable>
         ) : null}

         {props.diagnosis.main || props.diagnosis.chronic ? (
            <StyledFlex gap={8}>
               {props.diagnosis.main ? (
                  <StyledFlex gap={4} alignItems={'center'}>
                     <IconWrapper testId={'mainCheckIcon'} size={IconSize.SMALL}>
                        <CheckIcon />
                     </IconWrapper>
                     <Translate>{sidePanelTranslationKeys.medicalData.diagnosis.main}</Translate>
                  </StyledFlex>
               ) : null}

               {props.diagnosis.chronic ? (
                  <StyledFlex gap={4} alignItems={'center'}>
                     <IconWrapper testId={'chronicCheckIcon'} size={IconSize.SMALL}>
                        <CheckIcon />
                     </IconWrapper>
                     <Translate>{sidePanelTranslationKeys.medicalData.diagnosis.chronic}</Translate>
                  </StyledFlex>
               ) : null}
            </StyledFlex>
         ) : null}
      </StyledFlex>
   );
};
